import * as AWS from "aws-sdk";

export const AWS_S3_BUCKET = process.env.REACT_APP_AWS_BUCKET_NAME;
export const s3 = new AWS.S3({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  region:"us-east-2"
});